<script>
import axios from '@/utils/axios';
import { downloadPDF as downloadPDFUtil } from '@/utils/pdf-download';

export default {
inject: ['setLoading'],  
data() {
  return {
    errors: {},
    title: "Sales",
    text: "Sales",
    text1: "Invoice",
    invoice: [],
    admin: [],
    banks: [],
  };
},

computed: {

},

mounted() {
 const public_token = this.$route.params.public_token;
 this.invoiceByToken(public_token);
},

methods: {

 async invoiceByToken(public_token){
  this.errors = {};
  this.setLoading(true);
  try{
   const response = await axios.get(`invoices/${public_token}`);
   this.invoice = response.data.data;
   if(this.invoice?.admin_id){
    this.adminDetail(this.invoice.admin_id);
    this.adminBanks(this.invoice.admin_id);
   }
  }catch(error){
   this.$swalToast(error.message, 'error');
  }finally{
   this.setLoading(false);
  }
 },

 isExpired(){
  if(this.invoice?.due_date){
   const validUntil = new Date(this.invoice.due_date);
   // If date string is just a date, treat as end of day inclusive
   if(this.invoice.due_date.length === 10){
    validUntil.setHours(23, 59, 59, 999);
   }
   const now = new Date();
   return ( now > validUntil && this.invoice.status !== 'Paid');
  }
  return false;
 },

 async downloadPDF(module, id){
  await downloadPDFUtil(module, id);
 },

 async adminDetail(admin_id){
  try{
   const response = await axios.get(`admin/${admin_id}`);
   this.admin = response.data.data;
  }catch(error){
   console.log(error.message);
  }
 },

 async adminBanks(admin_id){
  try{
   const response = await axios.get(`banks/${admin_id}`);
   this.banks = response.data.data;
  }catch(error){
   console.log(error.message);
  }
 },

},

};
</script>

<style scoped>

body {
 font-family: 'Arial', sans-serif;
 background-color: #fff;
 margin: 0;
 padding: 0;
 font-size: 10.5px;
 color: #333333;
 line-height: 1.4;
}

table {
 border-collapse: collapse;
 border-spacing: 0;
 width: 100%;
}
td { vertical-align: top; padding: 0; }

.invoice-container {
 width: 100%;
 max-width: 210mm;
 margin: 15mm auto 0 auto; 
 background: #ffffff;
 padding: 0 10px 10px 10px;
}

.text-right { text-align: right; }
.text-center { text-align: center; }
.text-uppercase { text-transform: uppercase; letter-spacing: 0.05em; }
.font-bold { font-weight: 700; }
.font-heavy { font-weight: 800; }
.text-dark { color: #000000; }
.text-gray { color: #666666; }

.fs-10 { font-size: 10px; }
.fs-11 { font-size: 11px; }
.fs-12 { font-size: 12px; }
.fs-14 { font-size: 14px; }
.fs-20 { font-size: 20px; }
.fs-24 { font-size: 24px; }

.bordered-box { border: 1px solid #000000; }
.cell-padding { padding: 5px 6px; }

.header-box td {
 border: 1px solid #000000;
}
.header-title {
 background-color: #F5F5F5;
 border-bottom: 2px solid #000000;
 padding: 6px 0;
}

.address-detail-section { margin-top: 8px; }
.address-box {
 padding: 6px;
 border: 1px solid #000000;
 min-height: 70px;
}
.detail-table td { padding: 2px 0; }

.items-table { margin-top: 8px; }
.items-table thead th {
 background-color: #F5F5F5;
 color: #333333;
 padding: 6px 8px;
 font-size: 9.5px;
 text-transform: uppercase;
 text-align: left;
 font-weight: 600;
 border: 1px solid #000000;
}
.items-table tbody td {
 padding: 4px 8px;
 border: 1px solid #000000;
 color: #333333;
}

.totals-section { margin-top: 8px; page-break-inside: avoid; }
.totals-table td { padding: 4px 0; text-align: right; }

.total-label {
 color: #666666;
 font-size: 10.5px;
 padding-right: 10px;
}
.total-val {
 font-weight: 700;
 color: #000000;
 font-size: 11.5px;
}

.grand-total-row td {
 background-color: #F5F5F5;
 color: #000000;
 padding: 8px;
 font-size: 13px;
 font-weight: 800;
 border-top: 2px solid #000000;
}

.amount-in-words { padding: 6px 8px; }

.pay-now-button {
 background-color: #000000;
 color: #ffffff;
 padding: 6px 12px;
 text-decoration: none;
 font-weight: bold;
 font-size: 10px;
 border: 1px solid #000000;
 display: inline-block;
 text-align: center;
}

.footer-line {
 margin-top: 15px;
 border-top: 1px dashed #CCCCCC;
 padding-top: 4px;
 font-size: 9px;
 color: #666666;
 text-align: center;
}

@media print {
.invoice-container {
 width: 210mm;
 height: 277mm;
 margin: 0 auto;
 padding: 10mm 5mm 5mm 5mm;
 box-sizing: border-box;
}
.totals-section, .items-table {
 page-break-inside: avoid !important;
}
}
</style>

<template>

 <div class="content">
  <!-- Breadcrumb -->
  <div class="d-md-flex d-block align-items-center justify-content-end page-breadcrumb mb-3 mt-3">
    <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">

    <span class="badge bg-danger me-3" v-if="isExpired()">Expired</span>  
    <span class="badge bg-warning p-2 me-3">{{ invoice.status }}</span>  

    <a href="javascript:void(0);" class="btn btn-dark align-items-center me-3" @click="downloadPDF('invoices', invoice.id)">
    <i class="ti ti-download me-2"></i>Download</a>

   <!-- <div class="dropdown" v-if="!isExpired() && (invoice.status !== 'Paid')">
    <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown"><i class="ti ti-grip-vertical me-2"></i> Action</button>
    <ul class="dropdown-menu">
      <li><a class="dropdown-item" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#quotation_action" @click="$refs.invoiceModal.invoiceAction(invoice?.id, 'Paid')"> <i class="ti ti-check me-2"></i> Accept</a></li>
    </ul>
   </div> -->
   
 </div>

   </div>
 <!-- /Breadcrumb -->

<div class="invoice-container" style="position: relative;">

  <!-- Watermark -->
  <div class="watermark" style="opacity: 0.04; top:80px; position:absolute; left:0; right:0;" v-if="admin?.company?.watermark || admin?.company?.logo">
  <img :src="admin.company?.watermark_url || admin.company?.logo_url" alt="Watermark" style="width: 100%; height: auto;">
  </div>

  <!-- Header -->
  <table width="100%" cellpadding="0" cellspacing="0" border="1" class="bordered-box" style="position: relative; z-index: 1;">
  <thead>
    <tr>
     <td colspan="2" class="header-title text-center font-bold fs-14 text-uppercase">Invoice</td>
    </tr>
  </thead>
    <tr>
      <td width="70%" style="border-right: 1px solid #000000; padding: 6px;">
          <div style="margin-bottom: 6px;" v-if="admin?.company?.logo">
    <img :src="admin.company?.logo_url" alt="Company Logo" 
      style="height: 50px; width: auto; object-fit: contain;" />
  </div>
        <div class="fs-14 font-bold text-dark text-uppercase" style="margin-bottom: 3px;">
          {{ admin?.company?.company_name }}
        </div>

        <div class="fs-10 text-gray" style="line-height: 1.3;">
          <template v-if="admin?.company?.address">
            Address:
            {{ admin.company.address }},
            {{ admin.company.city }}
            -
            {{ admin.company.pincode }}<br>
            <template v-if="admin.company.gst">
              <strong>GSTIN:</strong> {{ admin.company.gst }} |
            </template>
            <template v-if="admin.company.email">
              <strong>Email:</strong> {{ admin.company.email }}
            </template>
          </template>
        </div>
      </td>

      <td width="30%" style="padding: 6px;">
        <table width="100%" class="detail-table fs-11">
          <tr>
            <td class="text-gray" style="width: 50%;">Invoice No:</td>
            <td class="text-right font-bold">{{ invoice?.invoice_number }}</td>
          </tr>
          <tr>
            <td class="text-gray">Issue Date:</td>
            <td class="text-right font-bold">
              {{ invoice?.issue_date ? $formatDate(invoice.issue_date, 'DD MMM YYYY') : 'N/A' }}
            </td>
          </tr>

          <tr v-if="invoice?.due_date">
            <td class="text-gray">Valid Until:</td>
            <td class="text-right font-bold">
              {{ $formatDate(invoice.due_date, 'DD MMM YYYY') }}
            </td>
          </tr>

          <tr v-if="invoice?.po_number && invoice.po_number !== 'N/A'">
            <td class="text-gray">P.O. Ref:</td>
            <td class="text-right font-bold">{{ invoice.po_number }}</td>
          </tr>
        </table>
      </td>
    </tr>
  </table>

  <!-- Bill To / Other Details -->
  <table width="100%" cellpadding="0" cellspacing="0" class="address-detail-section">
    <tr>
      <td width="50%" class="bordered-box" style="padding: 6px; border-right: none;">
        <div class="fs-10 text-uppercase font-bold text-dark" style="margin-bottom: 3px;">
          Bill To (Party)
        </div>
        <div class="fs-11 font-bold" style="text-transform:uppercase">
          {{ invoice?.to_name }}
        </div>
        <div class="fs-10 font-bold" style="text-transform:uppercase">
          {{ invoice?.to_phone }}
        </div>
        <div class="fs-10 font-bold" style="text-transform:uppercase" v-if="invoice?.to_email">
          {{ invoice?.to_email }}
        </div>
        <div class="fs-10 text-gray" style="line-height: 1.3; margin-top: 3px;">
          <template v-if="invoice?.to_address">
            {{ invoice.to_address }}<br>
          </template>
            {{ invoice.to_city }}<span v-if="invoice?.to_state">, {{ invoice?.to_state }} </span> - {{ invoice.to_pincode }}
        </div>
        <div class="fs-10" style="text-transform:uppercase" v-if="invoice?.gst_no">
          GSTIN: {{ invoice?.gst_no }}
        </div>
      </td>

      <td width="50%" class="bordered-box" style="padding: 6px;">
        <div class="fs-10 text-uppercase font-bold text-dark" style="margin-bottom: 3px;">
          Other Details
        </div>
        <div class="fs-10 text-gray" style="line-height: 1.3;">
          Place of Supply:
          <strong>{{ invoice?.place_of_supply || 'N/A' }}</strong><br>
          <template v-if="invoice?.quotation?.quotation_number && invoice.quotation.quotation_number !== 'N/A'">
            Quotation Ref:
            <strong>{{ invoice.quotation.quotation_number }}</strong>
          </template>
        </div>
      </td>
    </tr>
  </table>

  <!-- Items -->
  <table class="items-table bordered-box" cellspacing="0" cellpadding="0" style="position: relative; z-index: 1;">
    <thead>
      <tr>
        <th width="5%" class="text-center">S.No.</th>
        <th width="40%">Description of Goods/Services</th>
        <th width="10%" class="text-center">HSN/SAC</th>
        <th width="10%" class="text-center">Qty</th>
        <th width="10%" class="text-right">Rate</th>
        <th v-if="invoice?.tax_mode === 'Item'" width="10%" class="text-center"> Tax % </th>
        <th width="15%" class="text-right">Amount</th>
      </tr>
    </thead>
    <tbody>
     <tr v-for="(item, index) in invoice?.invoice_items || []" :key="item.id || index">
      <td class="text-center fs-10">{{ index + 1 }}</td>
       <td>
        <strong class="text-dark fs-10">{{ item.name }}</strong>
        <br v-if="item.description && item.description !== 'N/A'">
        <span v-if="item.description && item.description !== 'N/A'" class="text-gray fs-9" style="font-style: italic; white-space: pre-line;" v-html="item.description"></span>
        </td>
        <td class="text-center fs-10 text-gray"> {{ item.hsn_code || 'N/A' }} </td>
        <td class="text-center fs-10"> {{ item.quantity }} {{ item.unit }} </td>
        <td class="text-right fs-10"> {{ parseFloat(item.taxable_amount || 0).toFixed(2) }} </td>
        <td v-if="invoice?.tax_mode === 'Item'" class="text-center fs-10"> {{ item?.tax?.rate || 0 }}% </td>
        <td class="text-right font-bold fs-10 text-dark"> {{ parseFloat(item.total || 0).toFixed(2) }} </td>
      </tr>

      <!-- Empty filler rows to keep height -->
      <tr v-for="n in Math.max(0, 5 - (invoice?.invoice_items?.length || 0))" :key="'empty-'+n">
        <td class="text-center fs-10">-</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td v-if="invoice?.tax_mode === 'Item'"></td>
        <td></td>
      </tr>
    </tbody>
  </table>

  <!-- Totals / Terms / Signature -->
  <table width="100%" cellpadding="0" cellspacing="0" class="totals-section bordered-box" style="position: relative; z-index: 1;">
    <tr>
    <!-- Amount in words -->
    <td colspan="2" class="amount-in-words" style="border-right: 1px solid #000000; border-bottom: 1px solid #000000; padding: 6px;">
      <div class="fs-10 text-uppercase font-bold text-dark" style="margin-bottom: 3px;">
        Amount Chargeable (in words)
      </div>
      <div class="fs-11 font-heavy text-dark" style="text-transform: capitalize;">
        {{ $amountInWords(invoice?.total || 0) }} Only
      </div>
    </td>

    <!-- Right totals column -->
    <td width="35%" style="padding: 0;">
    <table class="totals-table" width="100%">
    <tr>
     <td class="total-label" style="border-top: 1px solid #000000;">Subtotal</td>
     <td class="total-val" style="border-top: 1px solid #000000; padding-right: 8px;">
        {{ parseFloat(invoice?.subtotal || 0).toFixed(2) }}
      </td>
    </tr>

      <!-- Tax - invoice level -->
      <tr v-if="invoice?.tax_mode === 'Invoice' && invoice?.tax">
        <td class="total-label">
          Tax ({{ invoice.tax.name }})
        </td>
        <td class="total-val" style="padding-right: 8px;">
          {{ parseFloat(invoice.tax_amount || 0).toFixed(2) }}
        </td>
      </tr>

      <!-- Tax - item breakdown -->
      <template v-else-if=" invoice?.tax_mode === 'Item' && invoice?.tax_breakdown && Object.keys(invoice.tax_breakdown).length > 0">
      <tr v-for="(taxData, key) in invoice.tax_breakdown" :key="key">
      <td class="total-label">
        {{ taxData.name }}
      </td>
      <td class="total-val" style="padding-right: 8px;">
        {{ parseFloat(taxData.tax_amount || 0).toFixed(2) }}
      </td>
      </tr>
      </template>

      <!-- Tax - simple total tax -->
      <tr v-else-if="invoice?.tax_mode === 'Item' && parseFloat(invoice?.tax_amount || 0) > 0">
       <td class="total-label">Total Tax</td>
       <td class="total-val" style="padding-right: 8px;">
        {{ parseFloat(invoice.tax_amount || 0).toFixed(2) }}
       </td>
      </tr>

      <!-- Discount -->
      <tr v-if="parseFloat(invoice?.discount || 0) > 0">
        <td class="total-label">Discount</td>
        <td class="total-val" style="padding-right: 8px; color: #666666;">
          - {{ parseFloat(invoice.discount || 0).toFixed(2) }}
        </td>
      </tr>

      <!-- Shipping -->
      <tr v-if="parseFloat(invoice?.transportation_cost || 0) > 0">
        <td class="total-label">Shipping</td>
        <td class="total-val" style="padding-right: 8px;">
          {{ parseFloat(invoice.transportation_cost || 0).toFixed(2) }}
        </td>
      </tr>

      <!-- Installation -->
      <tr v-if="parseFloat(invoice?.installation_cost || 0) > 0">
        <td class="total-label">Installation</td>
        <td class="total-val" style="padding-right: 8px;">
          {{ parseFloat(invoice.installation_cost || 0).toFixed(2) }}
        </td>
      </tr>

      <!-- Advance -->
      <tr v-if="parseFloat(invoice?.advance_amount || 0) > 0">
        <td class="total-label">Advance</td>
        <td class="total-val" style="padding-right: 8px;">
          {{ parseFloat(invoice.advance_amount || 0).toFixed(2) }}
        </td>
      </tr>

      <!-- Grand total -->
      <tr class="grand-total-row">
       <td style="text-align: left; padding-left: 8px; background-color: #F5F5F5; border-top: 1px solid #000000;">
          TOTAL
        </td>
        <td style="background-color: #F5F5F5; border-top: 1px solid #000000;">
          {{ invoice?.party?.currency?.code }}
          {{ parseFloat(invoice?.total || 0).toFixed(2) }}
        </td>
      </tr>

      <!-- Pay Now button -->
      <tr v-if="document_settings?.show_payment_button && invoice?.balance !== 0">
       <td colspan="2" style="padding: 3px 6px; border: 1px solid #000000;">
        <a :href="`${apiBaseUrl}/payment/invoices/${invoice?.public_token}`" class="pay-now-button" target="_blank">
          PAY NOW -
          {{ invoice?.party?.currency?.code }}
          {{ parseFloat(invoice?.balance || 0).toFixed(2) }}
        </a>
      </td>
      </tr>

      <!-- Balance -->
      <tr v-if="invoice?.balance !== undefined">
        <td class="total-label">Balance</td>
        <td class="total-val" style="padding-right: 8px;">
          {{ invoice?.party?.currency?.code }}
          {{ parseFloat(invoice?.balance || 0).toFixed(2) }}
        </td>
      </tr>
      </table>
     </td>
    </tr>

    <!-- Terms -->
    <tr>
     <td width="32.5%" style="border-right: 1px solid #000000; border-bottom: 1px solid #000000; padding: 6px;">
      <div class="fs-10 font-bold text-dark" style="margin-bottom: 3px;">
        Terms & Conditions
      </div>
      <div class="fs-10 text-gray" style="line-height: 1.3;">
        <template v-if="invoice?.terms">
          <div v-html="invoice.terms"></div>
        </template>
        <template v-else>
          1. Payment due upon receipt.<br>
          2. Subject to local jurisdiction.
        </template>
      </div>
     </td>

      <!-- Notes -->
      <td width="32.5%" style="padding: 6px; border-bottom: 1px solid #000000; border-right: 1px solid #000000;">
        <div class="fs-10 font-bold text-dark" style="margin-bottom: 3px;">
          Notes
        </div>
        <div class="fs-10 text-gray" style="line-height: 1.3;">
          <template v-if="invoice?.notes">
            <div v-html="invoice.notes"></div>
          </template>
          <template v-else>
            Thank you for your business.
          </template>
        </div>
      </td>
    </tr>

    <!-- Signature -->
    <tr>
     <td colspan="3" class="text-right" style="padding: 6px;">
      <div style="height: 40px; margin-bottom: 5px; text-align: right;">
       <img v-if="admin?.company?.signature_url" :src="admin.company.signature_url" alt="Signature" style="height: 40px; width: auto; object-fit: contain;">
      </div>

      <div style="font-weight: bold; color: #000000; margin-top: 10px; margin-bottom: 5px;">
       For <strong>{{ admin?.company?.company_name }}</strong>
      </div>

      <div class="fs-10 text-dark" style="border-top: 1px solid #000000; display: inline-block; padding-top: 4px; min-width: 150px; text-align: center;">
       Authorized Signatory
      </div>
      </td>
    </tr>
  </table>

  <div class="footer-line">
    This is a computer generated Invoice.
  </div>
 </div>

  <!-- /Invoices -->

    <!-- <div class="d-flex justify-content-center align-items-center mb-4">
      <a href="javascript:void(0);" class="btn btn-primary d-flex justify-content-center align-items-center me-2"><i class="ti ti-printer me-2"></i>Print Invoice</a>
      <a href="javascript:void(0);" class="btn btn-white d-flex justify-content-center align-items-center border"><i class="ti ti-copy me-2"></i>Clone Invoice</a>
    </div> -->
  </div>

 <invoice-modal ref="invoiceModal" @updated="invoiceByToken(invoice?.public_token)"></invoice-modal>
</template>
